import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

// @param candidateData: object
// example:
// {
//   "full_name": "Balqees qasem"
// }
export function updateSupervisor(supervisorData: object): Promise<ApiResponse> {
  return Axios.put("v1/supervisors/supervisors", supervisorData);
}

export function getSupervisors(): Promise<ApiResponse> {
  return Axios.get("v1/supervisors/supervisors");
}
